// xfnv1a — small fast deterministic hash producing a uint32 seed.
// Used as a deterministic seed source for the PRNG (see engine/prng.ts).

export function xfnv1a(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 16777619);
  }
  return h >>> 0;
}

export function hashSeed(...parts: (string | number)[]): number {
  return xfnv1a(parts.join(':'));
}
